import React from 'react';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { onModalOpen, onChangeDarkMode, onChangeHighcontrast, OnchangeRTLmode } from '../Redux/Actions/Actions';
import { logoutUser } from '../Redux/Actions/authActions';
import Header from '../Component/Comman/Header';
import Dashboard from './Dashboard/Dashboard';
import NewModal from '../Component/Comman/NewModal';
import Market from './Market/Market';
import WalletPage from './WalletPage/WalletPage';
import SecurityPage from './SecurityPage/SecurityPage';
import Identification from './Identification/Identification';
import ReferalPage from './ReferalPage/ReferalPage';
import BankAccountPage from './BankAccountPage/BankAccountPage';
import ProfilePage from './ProfilePage/ProfilePage';
import ForexPage from './ForexPage/ForexPage';
import CryptoPage from './CryptoPage/CryptoPage';
import GoldPage from './GoldPage/GoldPage';
import DepositPage from './DepositPage/DepositPage';
import WithdrawPage from './WithdrawPage/WithdrawPage';
import TransactionPage from './TransactionPage/TransactionPage';
import { getBaseUrl, buildPath } from '../utils/urlHelper';

function MainIndex(props) {
    const { modalopen, darkMode, highcontrast, rtlmode } = props.Mainreducer;
    const { activekey, GotoChangeMenu } = props;
    const baseUrl = getBaseUrl();
    return (
        <div className='main px-lg-4 px-md-4'>
            {activekey === "/chat" || activekey === "/documentation" ? "" :
                <Header
                    onModalOpen={(val) => { props.onModalOpen(true) }}
                    GotoChangeMenu={(val) => { GotoChangeMenu(val) }}
                />
            }
            <NewModal
                show={modalopen}
                highcontrast={highcontrast}
                darkMode={darkMode}
                onHide={(val) => { props.onModalOpen(false) }}
                onChangeDarkMode={() => { props.onChangeDarkMode(darkMode === 'dark' ? 'light' : 'dark') }}
                onChangeHighcontrast={() => { props.onChangeHighcontrast(highcontrast === 'high-contrast' ? 'light' : 'high-contrast') }}
                OnchangeRTLmode={() => { props.OnchangeRTLmode(rtlmode === 'rtl_mode' ? true : false) }}
            />
            {/* TradingView Ticker Strips */}
            {activekey !== "/chat" && activekey !== "/documentation" && (
                <div className="container-fluid px-0">
                    {/* Forex Ticker */}
                    <div className="row gx-0">
                        <div className="col-12">
                            <div className="card rounded-0 border-0" style={{ backgroundColor: '#000000', border: 'none' }}>
                                <div className="card-body p-0" style={{ backgroundColor: '#000000', padding: '0' }}>
                                    <iframe
                                        src="https://www.tradingview-widget.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22proName%22%3A%22FX%3AEURUSD%22%2C%22title%22%3A%22EUR%2FUSD%22%7D%2C%7B%22proName%22%3A%22FX%3AGBPUSD%22%2C%22title%22%3A%22GBP%2FUSD%22%7D%2C%7B%22proName%22%3A%22FX%3AUSDJPY%22%2C%22title%22%3A%22USD%2FJPY%22%7D%2C%7B%22proName%22%3A%22FX%3AAUDUSD%22%2C%22title%22%3A%22AUD%2FUSD%22%7D%2C%7B%22proName%22%3A%22FX%3AUSDCAD%22%2C%22title%22%3A%22USD%2FCAD%22%7D%2C%7B%22proName%22%3A%22FX%3AUSDCHF%22%2C%22title%22%3A%22USD%2FCHF%22%7D%5D%2C%22showSymbolLogo%22%3Atrue%2C%22colorTheme%22%3A%22dark%22%2C%22isTransparent%22%3Afalse%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A46%7D"
                                        style={{
                                            width: "100%",
                                            height: "46px",
                                            border: "none",
                                            backgroundColor: "#000000"
                                        }}
                                        allowTransparency="true"
                                        frameBorder="0"
                                        title="Forex Ticker"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Crypto Ticker */}
                    <div className="row gx-0">
                        <div className="col-12">
                            <div className="card rounded-0 border-0" style={{ backgroundColor: '#000000', border: 'none' }}>
                                <div className="card-body p-0" style={{ backgroundColor: '#000000', padding: '0' }}>
                                    <iframe
                                        src="https://www.tradingview-widget.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22proName%22%3A%22BINANCE%3ABTCUSDT%22%2C%22title%22%3A%22BTC%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3AETHUSDT%22%2C%22title%22%3A%22ETH%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3ABNBUSDT%22%2C%22title%22%3A%22BNB%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3AADAUSDT%22%2C%22title%22%3A%22ADA%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3AXRPUSDT%22%2C%22title%22%3A%22XRP%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3ASOLUSDT%22%2C%22title%22%3A%22SOL%2FUSDT%22%7D%5D%2C%22showSymbolLogo%22%3Atrue%2C%22colorTheme%22%3A%22dark%22%2C%22isTransparent%22%3Afalse%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A46%7D"
                                        style={{
                                            width: "100%",
                                            height: "46px",
                                            border: "none",
                                            backgroundColor: "#000000"
                                        }}
                                        allowTransparency="true"
                                        frameBorder="0"
                                        title="Crypto Ticker"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="body d-flex py-3 ">
                <Routes>
                    <Route exact path={buildPath('/')} element={<Dashboard />} />
                    <Route exact path={buildPath('/market')} element={<Market />} />
                    <Route exact path={buildPath('/wallet-page')} element={<WalletPage />} />
                    <Route exact path={buildPath('/security-page')} element={<SecurityPage />} />
                    <Route exact path={buildPath('/identification')} element={<Identification />} />
                    <Route exact path={buildPath('/refer-page')} element={<ReferalPage />} />
                    <Route exact path={buildPath('/bank-accounts')} element={<BankAccountPage />} />
                    <Route exact path={buildPath('/profile')} element={<ProfilePage />} />
                    <Route exact path={buildPath('/forex')} element={<ForexPage />} />
                    <Route exact path={buildPath('/crypto')} element={<CryptoPage />} />
                    <Route exact path={buildPath('/gold')} element={<GoldPage />} />
                    <Route exact path={buildPath('/deposit')} element={<DepositPage />} />
                    <Route exact path={buildPath('/withdraw')} element={<WithdrawPage />} />
                    <Route exact path={buildPath('/transactions')} element={<TransactionPage />} />
                </Routes>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => ({
    Mainreducer: state.Mainreducer,
})
export default connect(mapStateToProps, {
    onModalOpen,
    onChangeDarkMode,
    onChangeHighcontrast,
    OnchangeRTLmode,
    logoutUser
})(MainIndex);